export function canonSerial(value) {
  if (value == null) return "";
  const raw = typeof value === "object" ? (value.serial ?? "") : String(value);
  const separator = raw.indexOf(" - ");
  return (separator === -1 ? raw : raw.slice(0, separator))
    .trim()
    .toUpperCase();
}

export function toOnuOption(option) {
  if (option && typeof option === "object") {
    return {
      serial: String(option.serial ?? ""),
      cliente: String(option.cliente ?? ""),
    };
  }
  const raw = String(option ?? "");
  const separator = raw.indexOf(" - ");
  return separator === -1
    ? { serial: raw.trim(), cliente: "" }
    : {
        serial: raw.slice(0, separator).trim(),
        cliente: raw.slice(separator + 3).trim(),
      };
}
